import {NgModule} from '@angular/core';
import {GlobalModule} from '@app/core/global.module';
import {TreeSelectDialogComponent} from './tree-select-dialog.component';
import {TreeModule} from '../../../shared/directives/tree/tree.module';
import {ButtonModule} from '@components/button/modules/button.module';

@NgModule({
    declarations: [
        TreeSelectDialogComponent
    ],
    imports: [
        GlobalModule,
        TreeModule,
        ButtonModule
    ]
})
export class TreeSelectDialogModule {
}
